import { Link } from '@mui/material'
import {FormFieldProps, SelectOption} from '..'

const caption: FormFieldProps = {
  name: 'caption',
  type: 'text',
  label: 'Caption',
  required: true,
  placeholder: 'Chilling with my friends on the beach',
  help: 'Short name or summary for this Foto',
}

const story: FormFieldProps = {
  name: 'story',
  type: 'textarea',
  label: 'Story',
  required: false,
  rows: 5,
  placeholder: 'There I was, when all of a sudden... WHOA!',
  help: (
    <div>
      A little bit of commentary always helps to add some flavor. Reports are in Markdown format. For help with this format, check out this
      {' '}<Link href="https://www.markdownguide.org/cheat-sheet/">cheatsheet</Link> &
      {' '}<Link href="https://stackedit.io/app#">editor</Link>.
    </div>
  ),
}

const took: FormFieldProps = {
  name: 'took',
  type: 'date',
  label: 'Took',
  required: true,
  help: 'When the Foto was taken',
}

const rating: FormFieldProps = {
  name: 'rating',
  type: 'rating',
  label: 'Rating',
  help: 'Helps improve filtering, ordering, etc',
}

const location: FormFieldProps = {
  name: 'location',
  type: 'text',
  label: 'Location (LAT, LNG)',
  placeholder: 'LATITUDE, LONGITUDE',
  help: 'In case the geographic information was missing or incorrect when uploaded.',
}

const tags: FormFieldProps = {
  name: 'tags',
  type: 'select',
  label: 'Tags',
  options: [] as SelectOption[],
  creatable: true,
  searchable: true,
  multi: true,
  placeholder: 'Select zero or more tags...',
  help: 'Tags can help with organization & filtering',
}

export const UpdateFotoForm = {caption, story, took, rating, location, tags}
